/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { VocFileStreamResp } from '../models/voc-file-stream-resp';
import { VocWorklistQueryReq } from '../models/voc-worklist-query-req';
import { VocWorklistQueryResp } from '../models/voc-worklist-query-resp';

@Injectable({ providedIn: 'root' })
export class VocWorklistService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiVocWorklistQueryPost()` */
  static readonly ApiVocWorklistQueryPostPath = '/api/voc/worklist/query';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVocWorklistQueryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiVocWorklistQueryPost$Response(
    params?: {
      body?: VocWorklistQueryReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<VocWorklistQueryResp>>> {
    const rb = new RequestBuilder(this.rootUrl, VocWorklistService.ApiVocWorklistQueryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VocWorklistQueryResp>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVocWorklistQueryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiVocWorklistQueryPost(
    params?: {
      body?: VocWorklistQueryReq
    },
    context?: HttpContext
  ): Observable<Array<VocWorklistQueryResp>> {
    return this.apiVocWorklistQueryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VocWorklistQueryResp>>): Array<VocWorklistQueryResp> => r.body)
    );
  }

  /** Path part for operation `apiVocWorklistExportPost()` */
  static readonly ApiVocWorklistExportPostPath = '/api/voc/worklist/export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVocWorklistExportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiVocWorklistExportPost$Response(
    params?: {
      body?: VocWorklistQueryReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<VocFileStreamResp>> {
    const rb = new RequestBuilder(this.rootUrl, VocWorklistService.ApiVocWorklistExportPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VocFileStreamResp>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVocWorklistExportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiVocWorklistExportPost(
    params?: {
      body?: VocWorklistQueryReq
    },
    context?: HttpContext
  ): Observable<VocFileStreamResp> {
    return this.apiVocWorklistExportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<VocFileStreamResp>): VocFileStreamResp => r.body)
    );
  }

}
